
const ECDetailVideo = () => {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-4xl mx-auto px-6">
        <div className="relative rounded-2xl overflow-hidden mb-12 h-[360px] w-full">
          <video
            className="w-full h-full object-cover object-top"
            autoPlay
            muted
            playsInline
            loop
          >
            <source src="/image/ec-detail-mv.m4v" type="video/mp4" />
            <p>動画を再生するにはvideoタグをサポートしたブラウザが必要です。</p>
          </video>
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50"></div>
        </div>

        <div className="bg-white rounded-2xl shadow-[0_4px_24px_rgba(137,181,107,0.08)] p-8 md:p-10">
          <h2 className="text-xl font-bold text-gray-800 mb-5 font-['Noto_Sans_JP'] leading-relaxed">
            自信を持ってお勧めできるのは、作ったECサイトを自ら運営しているからこそ！<br />
            販路拡大のために「ECサイト」を導入しませんか？
          </h2>
          <p className="text-gray-700 text-sm leading-relaxed">
            新型コロナウイルス感染症により店頭販売の売り上げが低下し、ECサイトの需要は以前にも増して高まっています。<br />
            今ならIT導入補助金を利用し、格安で導入できます。あなたの事業でも「ECサイト」を導入してみませんか。
          </p>
        </div>
      </div>
    </section>
  );
};

export default ECDetailVideo;
